import {css} from 'styled-components';

export default function factory () {
  return css``;
}
